import $ from 'jquery';
import 'slick-carousel';
import Headroom from 'headroom.js';
import Isotope from './vendors/isotope.pkgd.js';
import 'jquery-inview';

$(document).ready(function($){
    headerAnimation();
    mobileMenu();
    heroSlideShow();
    teamSlideShow();
    jobsSlideShow();
    //animateClass();

    var elem = document.querySelector('.team-grid');
    if(elem) {
        var iso = new Isotope(elem, {
            // options
            itemSelector: '.grid-item',
            layoutMode: 'fitRows'
        });
    }

    $('.filter-button-group').on( 'click', 'button', function() {
        var filterValue = $(this).attr('data-filter');
        iso.arrange({ filter: filterValue });
    });

    $('.logo-item a').on('mouseover', function() {
        $(this).find('img').removeClass('gray');
    });
    $('.logo-item a').on('mouseleave', function() {
        $(this).find('img').addClass('gray');
    });

    if ($(window).width() > 992) {
        $('.hotspot-trigger').on('click', function() {
            $('.hotspot-trigger').removeClass('active');
            $(this).addClass('active');
            $('.hotspot-content').fadeOut();
            $(this).parent().find('.hotspot-content').fadeIn();
        });
    }

    if ($(window).width() < 992) {
        $('.hotspot-trigger-1').on('click', function() {
            $('.hotspot-trigger').removeClass('active');
            $(this).addClass('active');
            $('.hotspots-mobile .hotspot-content').css('display', 'none');
            $('.hotspots-mobile .hotspot-content.content-1').fadeIn(2000);
        });

        $('.hotspot-trigger-2').on('click', function() {
            $('.hotspot-trigger').removeClass('active');
            $(this).addClass('active');
            $('.hotspots-mobile .hotspot-content').css('display', 'none');
            $('.hotspots-mobile .hotspot-content.content-2').fadeIn(2000);
        });

        $('.hotspot-trigger-3').on('click', function() {
            $('.hotspot-trigger').removeClass('active');
            $(this).addClass('active');
            $('.hotspots-mobile .hotspot-content').css('display', 'none');
            $('.hotspots-mobile .hotspot-content.content-3').fadeIn(2000);
        });

        $('.hotspot-trigger-4').on('click', function() {
            $('.hotspot-trigger').removeClass('active');
            $(this).addClass('active');
            $('.hotspots-mobile .hotspot-content').css('display', 'none');
            $('.hotspots-mobile .hotspot-content.content-4').fadeIn(2000);
        });

        $('.hotspot-trigger-5').on('click', function() {
            $('.hotspot-trigger').removeClass('active');
            $(this).addClass('active');
            $('.hotspots-mobile .hotspot-content').css('display', 'none');
            $('.hotspots-mobile .hotspot-content.content-5').fadeIn(2000);
        });
    }

});

$(window).resize(function($){
    removeMobileMenu();
});

function animateClass() {
    $('.animate-in-view').one('inview', function(){
        $(this).addClass('animate');
    });
}

function headerAnimation() {
    var headerHieght = $('#main-header').outerHeight();
    var mobileHeaderHieght = $('#main-header').outerHeight();


    // grab an element
    var mainHeader = document.querySelector('#main-header');
// construct an instance of Headroom, passing the element
    var headroomMainHeader  = new Headroom(mainHeader);
// initialise
    headroomMainHeader.init({
        offset: headerHieght
    });


    // grab an element
    var mobileHeader = document.querySelector('#mobile-header');
    // construct an instance of Headroom, passing the element
    var headroomMobileHeader  = new Headroom(mobileHeader);
    // initialise
    headroomMobileHeader.init({
        offset: mobileHeaderHieght
    });
}

function mobileMenu() {
    var mobileHeader = $('#mobile-header'),
        mobileMenuToggle = mobileHeader.find('.mobile-menu-toggle'),
        mobileMenu = $('#mobile-menu');

    mobileMenuToggle.on('click', function(){
        mobileMenu.toggleClass('open inactive');
        $('body').toggleClass('no-scroll');
        mobileMenuToggle.find('.menu-icon').toggleClass('open');
        mobileMenuHeight();
    });
}

function mobileMenuHeight() {
    var windowWidth = $(window).width(),
        windowHeight = $(window).height(),
        mobileMenu = $('#mobile-menu'),
        headerHeight = $('#mobile-header').outerHeight(),
        mobileMenuHeight = windowHeight - headerHeight,
        mobileMenuTop = headerHeight;

    if ( windowWidth <= 991 ) {
        if ( mobileMenu.hasClass('open') ) {
            mobileMenu.css({'top': mobileMenuTop + 'px'});
        } else {
            mobileMenu.addClass('inactive');
        }
    } else {
        mobileMenu.addClass('inactive');
    }
}

function removeMobileMenu() {
    var windowWidth = $(window).width(),
        mobileMenu = $('#mobile-menu'),
        mobileHeader = $('#mobile-header'),
        mobileMenuToggle = mobileHeader.find('.mobile-menu-toggle');

    if ( windowWidth > 991 ) {
        mobileMenu.removeClass('open').addClass('inactive');
        $('body').removeClass('no-scroll');
        mobileMenuToggle.find('.menu-icon').removeClass('open');
        mobileMenuHeight();
    }
}

function heroSlideShow() {
    var slider = $('.hero-slideshow');

    slider.slick({
        infinite: true,
        speed: 300,
        dots: true,
        rows: 0
    });
}

function teamSlideShow() {
    var slider = $('.team-slider');

    slider.slick({
        infinite: true,
        speed: 300,
        dots: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1439,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });
}

function jobsSlideShow() {
    var slider = $('.jobs-slider');

    if ( slider.length ) {
      slider.slick({
          infinite: true,
          speed: 300,
          dots: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          responsive: [
              {
                  breakpoint: 1025,
                  settings: {
                      slidesToShow: 2
                  }
              },
              {
                  breakpoint: 640,
                  settings: {
                      slidesToShow: 1
                  }
              }
          ]
      });
    }
}
